import hexCode from './hexCode.js';

export default function objectToUrlQuery( obj )
{
	return Object.entries(obj).map
	(
		v =>
		{
			let v1 = v[1];
			while(typeof(v1) === 'function')
			{
				v1 = v1();
			}
			switch(typeof(v1))
			{
				case 'boolean':
				case 'number':
				case 'string':
				case 'symbol':
				case 'bigint':
					v1 = ''+v1;
					break;
				case 'undefined':
				case 'object':
					if(!v1)
					{
						return null;
					}
					v1 = objectToUrlQuery(v1);
			}
			return `${v[0].replace(/[#=&%]/g,hexCode)}=${v1.replace(/[#&%]/g,hexCode)}`;
		}
	)
	.filter(v => v)
	.join('&');
}
